import { provideApi } from '@/api/profile'
import { environment } from '@/environments/environment'
import { registerLocaleData } from '@angular/common'
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http'
import localeFr from '@angular/common/locales/fr'
import {
  ApplicationConfig,
  ErrorHandler,
  LOCALE_ID,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core'
import { provideRouter, withViewTransitions } from '@angular/router'
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalService,
} from '@azure/msal-angular'
import { routes } from './app.routes'
import { APP_INTERCEPTORS } from './config/http/interceptors'
import { MSALGuardConfigFactory, MSALInstanceFactory, MSALInterceptorConfigFactory } from './config/msal/msal.factories'
import { GlobalErrorHandler } from './core/errors/global-error.handler'

// Locale française enregistrée globalement : formats de dates/nombres cohérents (pipes date/number)
// et alignés sur les appels toLocaleDateString('fr-FR') du code.
registerLocaleData(localeFr, 'fr-FR')

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes, withViewTransitions()),
    // withFetch : backend fetch (défaut Angular 22, XHR déprécié). Les intercepteurs restent en
    // CLASSES via DI : MsalInterceptor l'impose, et il doit rester le plus EXTERNE — les
    // fonctionnels (withInterceptors) passeraient AVANT lui et l'intercepteur d'erreurs
    // toasterait alors les échecs d'acquisition de token MSAL.
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    ...APP_INTERCEPTORS,
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
    },
    provideAppInitializer((): Promise<void> => {
      const msal = inject(MsalService)
      return msal.instance.initialize()
    }),
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideApi(environment.apiConfig.profile.uri),
  ],
}

